import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tasks: []
  },

  mutations: {
    addTask (state, task) {
      state.tasks.push(task)
    },
    updateTaskState (state, payload) {
      const task = state.tasks.find(t => t.id === payload.id)
      task.state = payload.taskState
    },
    deleteTask (state, id) {
      const idx = state.tasks.indexOf(t => t.id === id)
      state.tasks.splice(idx, 1)
    }
  },

  actions: {
    addTask (context, task) {
      context.commit('addTask', task)
    },
    updateTaskState (context, payload) {
      context.commit('updateTaskState', payload)
    },
    deleteTask (context, id) {
      context.commit('deleteTask', id)
    }
  }
})
